import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';

export default function CardInfo({ title, content }: { title: string; content: string }) {
    return (
        <Grid item container direction="column" style={{ marginTop: 5 }}>
            <Text variant="caption">
                {title}{' '}
                <Text variant="caption" bold>
                    {content}
                </Text>
            </Text>
        </Grid>
    );
}
